import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Header from "./comman-pages/Header";
// import Footer from "./comman-pages/Footer";
import ScrollToTop from './comman-pages/ScrollToTop';
import ErrorBoundary from "./comman-pages/ErrorBoundary"; // Add an ErrorBoundary component
import LoadingSpinner from "./comman-pages/LoadingSpinner"; // Add a custom loader for Suspense fallback

// Lazy load components for better performance
const Header = lazy(() => import("./comman-pages/Header"));
const Footer = lazy(() => import("./comman-pages/Footer"));
const Home = lazy(() => import("./pages/Home"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const BrickInsightDashboard = lazy(() => import("./pages/BrickInsightDashboard"));
const ProjectBrickInsight = lazy(() => import("./pages/ProjectBrickInsight"));
const ProjectSchedulePreparation = lazy(() => import("./pages/ProjectSchedulePreparation"));
const BusinessProcessImprovement = lazy(() => import("./pages/BusinessProcessImprovement"));
const ErpNext = lazy(() => import("./pages/ErpNext"));
const ERPConsultancy = lazy(() => import("./pages/ERPConsultancy"));
const DataAnalytics = lazy(() => import("./pages/DataAnalytics"));
const Testimonial = lazy(() => import("./pages/Testimonial"));
const ErpMain = lazy(() => import("./pages/ErpMain"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Sap = lazy(() => import("./pages/sap")); // Lazy load the Sap component
const Salesforce = lazy(() => import("./pages/salesforce"));
const ProductEngineering = lazy(() => import("./pages/productengineering"));
const DigitalConsulting = lazy(() => import("./pages/DigitalConsulting")); // Lazy load the ProductEngineering component
const EngagementType = lazy(() => import("./pages/EngagementType"));


const App = () => {
  return (
    <Router> {/* (basename="/my-react-app") Set basename to match your subdirectory */}
      <Suspense fallback={<LoadingSpinner />}> {/* Show a loading spinner while lazy loading */}
        <ScrollToTop />
        <div className="wrapper">
          <ErrorBoundary>
            <Header />
            <div className="inner_pages">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/aboutus" element={<AboutUs />} />
                <Route path="/brickinsightdashboard" element={<BrickInsightDashboard />} />
                <Route path="/projectbrickinsight" element={<ProjectBrickInsight />} />
                <Route path="/projectschedulepreparation" element={<ProjectSchedulePreparation />} />
                <Route path="/businessprocessimprovement" element={<BusinessProcessImprovement />} />
                <Route path="/erpnext" element={<ErpNext />} />
                <Route path="/erpconsultancy" element={<ERPConsultancy />} />
                <Route path="/dataanalytics" element={<DataAnalytics />} />
                <Route path="/testimonial" element={<Testimonial />} />
                <Route path="/erpnextmain" element={<ErpMain />} />
                <Route path="/contactus" element={<ContactUs />} />
                 <Route path="/sap" element={<Sap />} />
                 <Route path="/salesforce" element={<Salesforce />} />
                 <Route path="/productengineering" element={<ProductEngineering />} />
                 <Route path="/digitalconsulting" element={<DigitalConsulting />} />
                 <Route path="/engagementtype" element={<EngagementType />} />
                 
              </Routes>
            </div>
            <Footer />
          </ErrorBoundary>
        </div>
      </Suspense>
    </Router>
  );
};

export default App;